/** Eastern is the app's reporting zone (ADR-0007) and the zone the API stamps its own export
 *  names in, so a fallback composed here lands on the same calendar day as the real name. */
const EASTERN_STAMP = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/New_York',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

/**
 * The `{module_name}_{timestamp}` name an export falls back to when the response carries no
 * `Content-Disposition` — an old API, or CORS not exposing the header.
 *
 * It exists so the degraded path still satisfies the convention rather than re-introducing the
 * seventeen ad-hoc, date-only and UUID-bearing strings this module replaced. It is **not** the
 * normal path: the server names its own files (see `useExport`).
 */
export function exportFallbackName(moduleSegment: string, now: Date = new Date()): string {
  const parts = EASTERN_STAMP.formatToParts(now).reduce<Record<string, string>>((acc, part) => {
    acc[part.type] = part.value;
    return acc;
  }, {});
  // en-CA renders midnight as hour "24"; the API's own formatter does not, so normalise.
  const hour = parts.hour === '24' ? '00' : parts.hour;
  return `${moduleSegment}_${parts.year}${parts.month}${parts.day}${hour}${parts.minute}${parts.second}`;
}
